import {FC, lazy, Suspense} from 'react'
import {Navigate, Route, Routes} from 'react-router-dom'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {getCSSVariableValue} from '../../_metronic/assets/ts/_utils'
import {WithChildren} from '../../_metronic/helpers'
import {useAuth} from "../modules/auth";

// 메뉴 기반 리다이렉트 컴포넌트 (절대경로 사용)
const MenuBasedRedirect: FC = () => {
  const {menu} = useAuth()
  if (menu && menu.length > 0) {
    // pages가 있는 첫 번째 메뉴 찾기 (대시보드 등 빈 메뉴 스킵)
    for (const m of menu) {
      if (m.pages && m.pages.length > 0) {
        return <Navigate to={m.pages[0].menuUrl} replace />
      }
    }
    // pages가 있는 메뉴가 없으면 첫 메뉴 URL 직접 사용
    return <Navigate to={menu[0].menuUrl} replace />
  }
  return <Navigate to='/auth' replace />
}

const PrivateRoutes = () => {
  const WizardsPage = lazy(() => import('../modules/wizards/WizardsPage'))
  const OcppLogPage = lazy(() => import('../modules/ocpp/ocpp-log/OcppLogPage'))
  const StationPage = lazy(() => import('../modules/station/StationPage'))
  const OperationPage = lazy(() => import('../modules/operation/OperationPage'))
  const StatisticsPage = lazy(() => import('../modules/statistics/StatisticsPage'))
  const CommonManagementPage = lazy(() => import('../modules/common_management/CommonManagementPage'))
  const FileManagementPage = lazy(() => import('../modules/file_management/FileManagementPage'))

  return (
    <Routes>
      <Route element={<MasterLayout/>}>
        <Route index element={<MenuBasedRedirect />} />
        <Route path='auth/*' element={<MenuBasedRedirect />} />
        <Route path='dashboard' element={<DashboardWrapper />} />
        {/* Lazy Modules */}

        <Route
          path='crafted/pages/wizards/*'
          element={
            <SuspensedView>
              <WizardsPage/>
            </SuspensedView>
          }
        />
        <Route
          path='ocpp/ocpp-log/*'
          element={
            <SuspensedView>
              <OcppLogPage/>
            </SuspensedView>
          }
        />
        <Route
          path='ocpp/pages/station/*'
          element={
            <SuspensedView>
              <StationPage/>
            </SuspensedView>
          }
        />
        <Route
          path='ocpp/pages/operation/*'
          element={
            <SuspensedView>
              <OperationPage/>
            </SuspensedView>
          }
        />
        <Route
          path='ocpp/pages/statistics/*'
          element={
            <SuspensedView>
              <StatisticsPage/>
            </SuspensedView>
          }
        />
        <Route
          path='ocpp/pages/common_management/*'
          element={
            <SuspensedView>
              <CommonManagementPage/>
            </SuspensedView>
          }
        />
        <Route
          path='ocpp/pages/file_management/*'
          element={
            <SuspensedView>
              <FileManagementPage/>
            </SuspensedView>
          }
        />
        {/* Page Not Found */}
        <Route path='*' element={<Navigate to='/error/404'/>}/>
      </Route>
    </Routes>
  )
}


const SuspensedView: FC<WithChildren> = ({children}) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress/>}>{children}</Suspense>
}

export {PrivateRoutes}
